<template>
  <div id="Home">
    <HeroSlider :sliderImages="sliderImages" />
    <WhyGroupTickets />
    <PartyAreas />
    <GroupSeating />
    <Schedule />
    <BookSuiteForm />
    <Suites />
  </div>
</template>

<script>
  import HeroSlider from "@/components/HeroSlider";
  import { homeImages } from "@/data/homeSliderData";
  import PartyAreas from "@/components/PartyAreas/PartyAreas";
  import GroupSeating from "@/components/GroupSeating/GroupSeating";
  import WhyGroupTickets from "@/components/WhyGroupTickets/WhyGroupTickets";
  import Schedule from "@/components/Schedule/Schedule";
  import BookSuiteForm from "@/components/Home/BookSuiteForm";
  import Suites from "@/components/Suites/Suites";

  export default {
    name: "Home",
    components: {
      HeroSlider,
      PartyAreas,
      GroupSeating,
      WhyGroupTickets,
      Schedule,
      BookSuiteForm,
      Suites
    },
    data() {
      return {
        sliderImages: homeImages,
      };
    },
  };
</script>

<style lang="scss" scoped>
  #Home {
    margin-top: 29px;
  }
</style>